import React from 'react';
import { MessageSquare, FileText, DollarSign } from 'lucide-react';

interface Tab {
  id: string;
  label: string;
  icon: React.ReactNode;
  count?: number;
}

interface JobContactSheetTabsProps {
  activeTab: string;
  onTabChange: (tabId: string) => void;
  timelineCount?: number;
  filesCount?: number;
}

const JobContactSheetTabs: React.FC<JobContactSheetTabsProps> = ({
  activeTab,
  onTabChange,
  timelineCount = 0,
  filesCount = 0,
}) => {
  const tabs: Tab[] = [
    {
      id: 'timeline',
      label: 'Timeline',
      icon: <MessageSquare className="h-4 w-4" />,
      count: timelineCount,
    },
    {
      id: 'files',
      label: 'Files',
      icon: <FileText className="h-4 w-4" />,
      count: filesCount,
    },
    {
      id: 'financial',
      label: 'Financial',
      icon: <DollarSign className="h-4 w-4" />,
    },
  ];

  return (
    <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
      <div className="px-6">
        <nav className="flex space-x-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`flex items-center space-x-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                activeTab === tab.id
                  ? 'border-accent-color text-accent-color dark:text-accent-color-400'
                  : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
              }`}
            >
              {tab.icon}
              <span>{tab.label}</span>
              {tab.count !== undefined && tab.count > 0 && (
                <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${
                  activeTab === tab.id
                    ? 'bg-accent-color-100 text-accent-color-800 dark:bg-accent-color-900 dark:text-accent-color-200'
                    : 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300'
                }`}>
                  {tab.count}
                </span>
              )}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default JobContactSheetTabs;
